function PrivacyPolicyPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 text-gray-800">
      <h1 className="text-2xl md:text-3xl font-bold text-center">MossAura隐私政策</h1>
      <p className="mt-2 text-center text-sm text-gray-400">新版-V20260727</p>

      <section className="mt-10">
        <h2 className="text-lg font-semibold">1 引言</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          新译信息科技（深圳）有限公司（MossAura 的应用运营方和个人信息处理者，以下简称“我公司”或“我们”）重视用户的隐私。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的我公司服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          如对本《隐私政策》或相关事宜有任何问题，请通过support@newtranx.com与我们联系。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">2 我们可能收集的信息</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">3 您提供的信息</h2>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如电话号码、电子邮件或银行卡号等；</li>
          <li>您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。</li>
        </ul>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">4 其他方分享的您的信息</h2>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>其他方使用我们的服务时所提供有关您的共享信息。</li>
        </ul>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">5 我们获取的您的信息</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">您使用服务时我们可能收集如下信息：</p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>
            日志信息，指您使用我们的服务时，系统可能通过cookies、web beacon或其他方式自动采集的技术信息，包括：
            <ul className="mt-2 space-y-2 list-disc pl-5">
              <li>设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；</li>
              <li>
                Android_ID：在您同意本《隐私政策》后，为保障账号与服务安全、识别异常设备、进行设备适配和故障分析，我们可能通过Android系统接口获取Android_ID。Android_ID仅用于上述目的；我们不会在您同意本《隐私政策》前读取Android_ID。若Android_ID由第三方SDK获取，我们将在第三方SDK清单中列明该SDK的名称、提供方、处理目的及隐私政策链接。
              </li>
              <li>在使用我们服务时搜索或浏览的信息，例如在使用我们服务时浏览或要求提供的其他信息和内容详情；</li>
              <li>有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；</li>
              <li>您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。</li>
            </ul>
          </li>
          <li>
            位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：
            <ul className="mt-2 space-y-2 list-disc pl-5">
              <li>您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；</li>
              <li>
                您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人上传的照片包含的地理标记信息；
              </li>
              <li>您可以通过关闭定位功能，停止对您的地理位置信息的收集。</li>
            </ul>
          </li>
        </ul>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">6 我们可能如何使用信息</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：</p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>向您提供服务；</li>
          <li>在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；</li>
          <li>帮助我们设计新服务，改善我们现有服务；</li>
          <li>使我们了解您如何接入和使用我们的服务，从而改进服务的功能、稳定性和使用体验；</li>
          <li>软件认证或管理软件升级；</li>
          <li>让您参与有关我们产品和服务的调查。</li>
        </ul>
        <p className="mt-3 leading-7 text-sm md:text-base">
          为了改善服务，在符合相关法律法规且不超出本政策所列目的的前提下，我们可能对收集的信息进行汇总分析。若我们拟将个人信息用于本政策未载明的其他用途，我们将另行向您告知并依法取得您的同意。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">7 您如何访问和控制自己的个人信息</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          账号注销：如您需要注销MossAura账号，可向support@newtranx.com发送邮件，邮件主题注明“MossAura账号注销”，并在邮件中提供需要注销的账号以及完成身份核验所必需的信息。我们将在完成身份核验后的15个工作日内处理注销申请。账号注销后，我们将删除或匿名化处理与该账号相关的个人信息，法律法规另有规定的除外；账号注销后通常无法恢复，请谨慎操作。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">8 我们可能分享的信息</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：</p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>
            我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：
            <ul className="mt-2 space-y-2 list-disc pl-5">
              <li>⑴ 向您提供我们的服务；</li>
              <li>⑵ 实现“我们可能如何使用信息”部分所述目的；</li>
              <li>⑶ 履行我们在《用户协议》或本《隐私政策》中的义务和行使我们的权利；</li>
              <li>⑷ 理解、维护和改善我们的服务。</li>
            </ul>
          </li>
        </ul>
        <p className="mt-3 leading-7 text-sm md:text-base">
          如我们或我们的关联公司与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。
        </p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。</li>
          <li>
            我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：
            <ul className="mt-2 space-y-2 list-disc pl-5">
              <li>⑴ 遵守适用的法律法规；</li>
              <li>⑵ 遵守法院命令或其他法律程序的规定；</li>
              <li>⑶ 遵守相关政府机关的要求；</li>
              <li>⑷ 为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。</li>
            </ul>
          </li>
        </ul>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">9 未成年人隐私权的保护</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          本网站将建立和维持一合理的程序，以保护未成年人个人资料的保密性及安全性。本网站郑重声明：任何16岁以下的未成年人参加网上活动应事先得到家长或其法定监护人（以下统称为&quot;监护人&quot;）的可经查证的同意。监护人应承担保护未成年人在网络环境下的隐私权的首要责任。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          本网站收集未成年人的个人资料，仅为回覆未成人特定要求的目的，一俟回复完毕即从记录中删除，而不会保留这些资料做进一步的利用。未经监护人之同意，本网站将不会使用未成年人之个人资料，亦不会向任何第三方披露或传送可识别该未成人的个人资料。本网站如收集监护人或未成年人的姓名或其它网络通讯资料之目的仅是为获得监护人同意，则在经过一段合理时间仍未获得同意时，将主动从记录中删除此类资料若经未成人之监护人同意，本网站可对未成年人之个人资料进行收集，本网站将向监护人提供：
        </p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>⑴ 审视自其子女或被监护人收集之资料的机会；</li>
          <li>⑵ 拒绝其子女或被监护人的个人资料被进一步的收集或利用的机会；</li>
          <li>⑶ 变更或删除其子女或被监护人个人资料的方式。</li>
          <li>⑷ 监护人有权拒绝本网站与其子女或被监护人做进一步的联络。</li>
        </ul>
        <p className="mt-3 leading-7 text-sm md:text-base">
          本网站收集未成年人的个人资料，这些资料只是单纯作为保护未成年人参与网络活动时的安全，而非作为其它目的之利用。本网站保证不会要求未成年人提供额外的个人资料，以作为允许其参与网上活动的条件。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">10 信息安全</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们仅在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。
        </p>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">11 我们可能如何收集信息</h2>
        <p className="mt-3 leading-7 text-sm md:text-base">
          我们或我们的第三方合作伙伴，可能通过cookies和web beacon收集和使用您的信息，并将该等信息储存为日志信息。我们使用自己的cookies和web beacon，目的是为您提供更个性化的用户体验和服务，并用于以下用途：
        </p>
        <ul className="mt-3 space-y-2 text-sm md:text-base list-disc pl-5">
          <li>记住您的身份。例如：cookies和web beacon有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息；</li>
          <li>分析您使用我们服务的情况。例如，我们可利用cookies和web beacon来了解您使用我们的服务进行什么活动，或哪些网页或服务最受您的欢迎；</li>
        </ul>
        <p className="mt-3 leading-7 text-sm md:text-base">
          您可以通过浏览器设置拒绝或管理cookies或web beacon。但请注意，如果停用cookies或web beacon，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicyPage;
